<template>
    <v-app id="offer-confirm">
        <v-sheet width="100%" max-width="1144" class="d-none d-md-block pt-9 pl-5 pb-12 mx-auto">
            <vb-breadcrumb class="mt-0 mb-8" :breadcrumb="breadcrumb"/>
            <h1 class="pl-5">買取お申込み</h1>
        </v-sheet>

        <v-container class="mb-3" :class="$vuetify.breakpoint.mdAndUp ? 'fixed-width' : 'pt-0'">
          <vb-form-section title="集荷先情報">
            <vb-form-row item-name="本人確認書類">
              <template #input>
                {{ selectedIdentitySubmissionMethod }}
              </template>
            </vb-form-row>
            <vb-form-row item-name="氏名">
              <template #input>
                {{ getBuyFormItems.lastname }}&nbsp;{{ getBuyFormItems.firstname }}
              </template>
            </vb-form-row>
            <vb-form-row item-name="カナ">
              <template #input>
                {{ getBuyFormItems.lastnameKatakana }}&nbsp;{{ getBuyFormItems.firstnameKatakana }}
              </template>
            </vb-form-row>
            <vb-form-row item-name="生年月日">
              <template #input>
                {{
                  new Intl.DateTimeFormat('ja-JP', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  }).format(new Date(getBuyFormItems.birthdate))
                }}
              </template>
            </vb-form-row>
            <vb-form-row item-name="郵便番号">
              <template #input>
                {{ getBuyFormItems.postcode }}
              </template>
            </vb-form-row>
            <vb-form-row item-name="集荷先住所">
              <template #input>
                {{ getBuyFormItems.addressPrefecture }}<br/>
                {{ getBuyFormItems.addressLocal1 }}<br/>
                {{ getBuyFormItems.addressLocal2 }}
              </template>
            </vb-form-row>
            <vb-form-row item-name="ご職業">
              <template #input>
                {{ getBuyFormItems.jobLabel }}
              </template>
            </vb-form-row>
            <vb-form-row item-name="電話番号">
              <template #input>
                {{ getBuyFormItems.telephoneNumber1 }} - {{ getBuyFormItems.telephoneNumber2 }} -
                {{ getBuyFormItems.telephoneNumber3 }}
              </template>
            </vb-form-row>
          </vb-form-section>
          <vb-form-section title="お申込み内容">
            <vb-form-row item-name="箱数">
              <template #input>
                {{ getBuyFormItems.numberOfPackages }} 箱
                <p class="my-0 error--text">（{{ (getBuyFormLabels.isShippingFree || getBuyFormLabels.isShippingFreeAutoApplication) ? "送料無料" : "送料　" + shippingCostCalculation + "円" }}）</p>
              </template>
            </vb-form-row>
            <vb-form-row item-name="集荷希望日時">
              <template #input>
                {{ formattedPickupDate }}
                {{ getBuyFormLabels.pickupPeriodName }}
              </template>
            </vb-form-row>
            <vb-form-row item-name="ソクフリ">
              <template #input>
                {{ previewSokufuriApplication }}
                <p v-if="getBuyFormItems.sokufuriApplicationCode === 1" class="my-0 error--text">（{{getBuyFormLabels.immediateTransferPriceText}}が{{ getBuyFormLabels.immediateTransferApplyAmount }}円増額されます。）</p>
              </template>
            </vb-form-row>
            <vb-form-row item-name="anniversaryCampaignTitle" :class="getBuyFormLabels.selectedCampaignName ? '' : 'd-none'" :hide-item-name="true">
              <template #title>
                <div class="text-right">
                  <template>
                    {{ anniversaryCampaignTitle }}
                  </template>
                </div>
              </template>
              <template #input>
                {{ getBuyFormLabels.selectedCampaignName }}
              </template>
            </vb-form-row>
            <vb-form-row item-name="クーポンコード">
              <template #input>
                <template v-if="getBuyFormItems.campaignCode">
                  <v-sheet>
                    {{ getBuyFormItems.campaignCode }}
                    <p class="text-caption primary--text mb-0">{{ getBuyFormLabels.formattedCampaignName }}が適用されます</p>
                  </v-sheet>
                </template>
                <template v-else>
                  (なし)
                </template>
              </template>
            </vb-form-row>
            <vb-form-row item-name="下取りコード">
              <template #input>
                {{ getBuyFormItems.buybackCode ? getBuyFormItems.buybackCode : '(なし)'}}
              </template>
            </vb-form-row>
          </vb-form-section>

            <v-row justify="center" class="mt-md-6">
                <v-btn
                    class="secondary white--text text-subtitle-1 text-md-h6 mt-16"
                    :width="$vuetify.breakpoint.mdAndUp ? '500px' : '328px'"
                    :height="$vuetify.breakpoint.mdAndUp ? '76px' : '48px'"
                    :to="{name: 'BuyCompleted'}"
                    :disabled="isButtonDisabled"
                >
                    送信
                </v-btn>
            </v-row>

            <v-row justify="center">
                <v-btn
                    class="text-subtitle-1 text-md-h6 my-12"
                    :width="$vuetify.breakpoint.mdAndUp ? '500px' : '328px'"
                    :height="$vuetify.breakpoint.mdAndUp ? '76px' : '48px'"
                    :to="{name: 'RegistrationCompleted', params: {isBackButton: true}}"
                >
                    修正する
                </v-btn>
            </v-row>
        </v-container>

        <v-dialog v-model="dialogPickupTimeDeadlineExceeded" width="300" :persistent="true">
            <v-card>
                <v-card-title class="text-h6">
                    集荷の受付可能日時を過ぎています
                </v-card-title>
                <v-card-text>
                    <v-row>ご指定の集荷日時は、すでに受付可能な日時を過ぎています。</v-row>
                    <v-row>恐れ入りますが、再度お申込みください。</v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="mx-auto" @click="dialogPickupTimeDeadlineExceeded = false">閉じる</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogUnacceptableError" width="300">
            <v-card>
                <v-card-title class="text-h6">
                    エラーが発生しました
                </v-card-title>
                <v-card-text>
                    <v-row>{{ this.dialogUnacceptableErrorDescription }}</v-row>
                    <v-row>ダイアログを閉じて、入力内容を修正してください</v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="mx-auto" @click="dialogUnacceptableError = false">閉じる</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogFatalError" width="300">
            <v-card>
                <v-card-title class="text-h6 my-4 justify-center">
                    エラーが発生しました
                </v-card-title>
                <v-card-text>
                    <v-row>エラーを検出したため、実行することができませんでした。</v-row>
                    <v-row>しばらく時間をおいてからもう一度アクセスして頂くか、管理者にお問い合わせください。</v-row>
                </v-card-text>
                <v-card-actions class="my-4">
                    <v-spacer></v-spacer>
                    <v-btn @click="dialogFatalError = false">閉じる</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>


<script>
import {mapGetters, mapMutations} from "vuex";
import GtmOnVue from "../../../libs/gtmOnVue.js";
import VbBreadcrumb from "../../atoms/vb-breadcrumb.vue";
import VbFormSection from "../../organisms/buy/vb-form-section.vue";
import VbFormRow from "../../molecules/buy/vb-form-row.vue";


window.addEventListener('beforeunload', function (event) {
    if (document.getElementById('offer-confirm')) {
        // 離脱しようとしていることを、ダイアログで表示する
        event.preventDefault();
        event.returnValue = 'Check';
    }
});

export default {
    name: "buy-confirm",
    components: {
      VbFormRow,
      VbFormSection,
      VbBreadcrumb,
    },
    beforeRouteEnter(to, from, next) {
        // Back to the form page, if this confirmation page is reloaded.
        if (!from.name) {
            next({name: "RegistrationCompleted"});
            return;
        }

        if (from.name === 'BuyCompleted') {
            window.location.href = '/sell/offer'
            return;
        }
        next();
    },
    beforeRouteLeave(to, from, next) {
        this.isButtonDisabled = true;
        this.setPickupTimeOffset(null);

        if (to.name !== 'BuyCompleted') {
            next();
            return;
        }

        axios.post(
            '/api/buy/apply',
            {
                ...this.getBuyFormItems,
                ...this.getMemberFormItems,
            },
        ).then(response => {
            if (response.status === 200) {
                GtmOnVue.sendGAEvent(
                    'conversion_buy',
                    '/sell/offer-thx-registration/confirm',
                    response.data.buyID,
                    response.data.textboxCouponCode,
                    response.data.autoAppliedCouponCode,
                    response.data.selectedCouponCode,
                    response.data.buybackCode,
                    response.data.subscribesAllMailTypes,
                    response.data.numberOfPackages,
                    response.data.pickupDateISO8601,
                    response.data.pickupTimeCode,
                    response.data.isSokufuri,
                    response.data.isIntroduced,
                    response.data.introductionCode,
                );

                next();
            }
        }).catch(e => {
            console.error(e);

            if (e.response.status === 422) {
                if (e.response.data.cause === 'Failed to request the pickup.') {
                    this.dialogPickupTimeDeadlineExceeded = true;
                    return false;
                }

                this.dialogUnacceptableError = true;
                this.dialogUnacceptableErrorDescription = e.response.data.cause;
                return false;
            }

            if (e.response.status === 500) {
                this.dialogFatalError = true;
                return false;
            }
        }).finally(() => {
            this.isButtonDisabled = false;
        });
    },
    computed: {
      ...mapGetters({
        getMemberFormItems: 'member/getFormItems',
        getBuyFormItems: 'buy/getFormItems',
        getBuyFormLabels: 'buy/getFormLabels',
        selectedIdentitySubmissionMethod: 'buy/getSelectedIdentitySubmissionMethod',
        shippingCostCalculation: 'buy/getShippingCostCalculation',
        formattedPickupDate: 'buy/getFormattedPickupDate',
        previewSokufuriApplication: 'buy/getPreviewSokufuriApplication'
      }),
    },
    data() {
        return {
            anniversaryCampaignTitle:  VueConfig.sell.anniversaryCampaign.title,
            anniversaryCampaignUrl:  VueConfig.sell.anniversaryCampaign.url,
            breadcrumb: [
                {url: '/', name: 'TOP'},
                {url: null, name: '買取お申込み'},
            ],
            dialogPickupTimeDeadlineExceeded: false,
            dialogUnacceptableError: false,
            dialogUnacceptableErrorDescription: null,
            dialogFatalError: false,
            isButtonDisabled: false,
        };
    },
    methods: {
        ...mapMutations({
          setPickupTimeOffset: 'buy/setPickupTimeOffset',
        }),
    },
}
</script>

<style scoped lang="scss">
.fixed-width {
    max-width: 1024px;
}

h1 {
    color: #1F3134;
    font-size: 30px;
    font-family: $hira_w1;
    padding-left: 36px;
}

::v-deep {
    .row {
        margin-top: 0;
        margin-bottom: 0;
    }
    .v-application--wrap {
        min-height: unset;
    }

    .breadcrumb-list {
        ul {
            padding-left: 0 !important;
        }
    }
}
</style>